import { inject, Service, signal } from '@angular/core';
import { AVAILABLE_LANGUAGES } from '@constants';
import { logError } from '@shared/utils';
import { TimeagoIntl } from 'ngx-timeago';

const loadEnglishTimeagoStrings = () =>
  import('ngx-timeago/language-strings/en');

const TIMEAGO_STRINGS: Record<
  string,
  () => Promise<{ strings: TimeagoIntl['strings'] }>
> = {
  de: () => import('ngx-timeago/language-strings/de'),
  en: loadEnglishTimeagoStrings,
  es: () => import('ngx-timeago/language-strings/es'),
  fr: () => import('ngx-timeago/language-strings/fr'),
  it: () => import('ngx-timeago/language-strings/it'),
};

@Service()
export class DateService {
  intl = inject(TimeagoIntl);

  isLoadingTimeagoIntl = signal(false);

  loadLocaleStrings = async (locale: string) => {
    const selectedLocale = (AVAILABLE_LANGUAGES as readonly string[]).includes(
      locale
    )
      ? locale
      : 'en';

    this.isLoadingTimeagoIntl.set(true);

    try {
      const loadStrings =
        TIMEAGO_STRINGS[selectedLocale] ?? loadEnglishTimeagoStrings;
      const { strings } = await loadStrings();

      this.intl.strings = strings;
      this.intl.changes.next();

      this.isLoadingTimeagoIntl.set(false);
    } catch (error) {
      logError('Error loading locale strings', error);
      this.isLoadingTimeagoIntl.set(false);
    }
  };
}
